import AppContainer from 'app_components/layouts/app'
import TutorialsModule from 'app_components/modules/TutorialsModule/TutorialsModule'
import { CombinedReducers } from 'app_events/index'
import HomeService from 'app_services/user/homeService'
import React, { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

const TutorialsPrivatePage: FC = () => {
  const homeService: HomeService = useMemo(() => new HomeService(), [])
  const app = useSelector((state: CombinedReducers) => state.app)
  return homeService.renderLayout({
    app,
    children: (
      <TutorialsModule privateLanding />
    )
    // @ts-ignore
  }, AppContainer)
}

export default TutorialsPrivatePage
